"use strict";

var SPACING_ALIAS = {
  tiny: 'spacing-tiny',
  xxxs: 'spacing-xxxs',
  xxs: 'spacing-xxs',
  xs: 'spacing-xs',
  s: 'spacing-s',
  m: 'spacing-m',
  l: 'spacing-l',
  xl: 'spacing-xl',
  xxl: 'spacing-xxl',
  xxxl: 'spacing-xxxl',
  huge: 'spacing-huge'
};
var SHADOW_ALIAS = {
  default: 'shadow-default',
  sidebar: 'shadow-sidebar',
  modal: 'shadow-modal',
  /*
   * @deprecated: instead of this use dropdown
   */
  popover: 'shadow-popover',
  dropdown: 'shadow-dropdown',
  defaultHover: 'shadow-default-hover',
  modalMobile: 'shadow-modal-mobile',
  tooltip: 'shadow-tooltip'
};
var MEDIA_ALIAS = {
  phoneSmall: 'PHONE_SMALL',
  phoneGiant: 'PHONE_GIANT',
  phone: 'PHONE',
  mediumTablets: 'MEDIUM_TABLETS',
  tablets: 'TABLETS',
  mobile: 'MOBILE',
  desktop: 'DESKTOP',
  desktopSmall: 'DESKTOP_SMALL',
  desktopMedium: 'DESKTOP_MEDIUM',
  desktopLargeBoard: 'DESKTOP_LARGE_BOARD',
  desktopLarge: 'DESKTOP_LARGE',
  desktopExtraLarge: 'DESKTOP_EXTRA_LARGE',
  tabletS: 'TABLET_S',
  tabletL: 'TABLET_L',
  desktopS: 'DESKTOP_S',
  desktopMd: 'DESKTOP_MD',
  desktopM: 'DESKTOP_M',
  desktopL: 'DESKTOP_L'
};
var LAYERS_ALIAS = {
  hidden: 'layer-hidden',
  zero: 'layer-zero',
  normal: 'layer-normal',
  popover: 'layer-popover',
  navigation: 'layer-navigation',
  overlay: 'layer-overlay',
  alert: 'layer-alerts'
};
var BORDER_ALIAS = {
  defaultS: 'border-default-s',
  defaultL: 'border-default-l',
  radiusS: 'border-radius-s',
  radiusL: 'border-radius-l'
};
module.exports = {
  SPACING_ALIAS: SPACING_ALIAS,
  SHADOW_ALIAS: SHADOW_ALIAS,
  MEDIA_ALIAS: MEDIA_ALIAS,
  LAYERS_ALIAS: LAYERS_ALIAS,
  BORDER_ALIAS: BORDER_ALIAS
};